import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { useApi } from "../../api";
import { onboardingSteps, handleResetStep } from "../general/steps";
import { CENTERED_COLUMN_CLASSNAME } from "../general";
import { Button } from "../../ui/layout/molecules/Button";
import { START_NEW_NOTICE, BUTTONS_TITLE, TEXT_STYLE } from "./constants";
import { useEmailVerify, useIsSsoUser } from "../hooks";
import { ContactAdminNotice } from "./ContactAdminNotice";

const BUTTON_STYLE = "flex sm:w-36 w-full items-center justify-center";

type RegisterType = "currentCompany" | "startNewCompany";

export const NoCompanyForm: FC<React.PropsWithChildren> = () => {
  const [registerType, setRegisterType] = useState<RegisterType>();

  const [startNewEnabled, setStartNewEnabled] = useState<boolean>();
  const [showStartNewNotice, setShowStartNewNotice] = useState(false);

  const { getApi } = useApi();
  const navigate = useNavigate();

  useEmailVerify();

  const isSsoUser = useIsSsoUser();

  useEffect(() => {
    // Wait until we positively know this isn't an SSO user (rather than
    // treating "not yet known" as "not SSO") so a direct/refreshed
    // navigation to this page doesn't fire an API call that's about to be
    // thrown away once isSsoUser resolves true.
    if (startNewEnabled !== undefined || isSsoUser !== false) return;

    const isOnboardingAllowed = async () => {
      try {
        const api = await getApi();
        if (!api) return;

        const result = await api.isOnboardingAllowed();
        setStartNewEnabled(result.value.allowed);
      } catch (error) {}
    };
    isOnboardingAllowed();
  }, [getApi, startNewEnabled, isSsoUser]);

  if (isSsoUser) {
    return (
      <div className={CENTERED_COLUMN_CLASSNAME}>
        <ContactAdminNotice />
      </div>
    );
  }

  const handleStartNewCompany = () => {
    if (startNewEnabled) {
      onboardingSteps.map(handleResetStep);

      navigate("/auth/onboarding", { replace: true });
    } else {
      setShowStartNewNotice(true);
    }
  };

  const { usingVviinn, startNew } = BUTTONS_TITLE;

  return (
    <div className={CENTERED_COLUMN_CLASSNAME}>
      <div className="mb-4 dark:text-white">
        To finalize the registration choose your option:
      </div>

      <div className="mt-4 flex gap-2">
        <Button
          buttonType="secondary"
          title={usingVviinn}
          className={BUTTON_STYLE}
          onClick={() => setRegisterType("currentCompany")}
          capitalize={false}
        />
        <Button
          buttonType="secondary"
          title={startNew}
          className={BUTTON_STYLE}
          onClick={handleStartNewCompany}
          capitalize={false}
        />
      </div>

      {showStartNewNotice && <p className={TEXT_STYLE}>{START_NEW_NOTICE}</p>}

      {registerType === "currentCompany" && <ContactAdminNotice />}
    </div>
  );
};
